// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"133":"92f79a1837871a98","329":"7bb4821811dddd1b","716":"7a176cc29aa149f7","784":"700647433dd4d1db","955":"9a9d59006bc9ce05"}[chunkId] + ".js";
};